<div class="keycloak-auth">
  <div class="loader"></div>
</div>
